import { images } from '../assets';

export const services = [
  {
    id: 1,
    title: 'Car Wash Services',
    description:
      'Keep your car spotless with our premium car washing and detailing services. We offer exterior washing, interior cleaning, and full detailing packages.',
    image: images.carWash,
    detailedDescription: `Rediscover the joy of driving a spotless car with our premier car wash packages. 

**Packages**:
1. Express Shine: A 15-minute quick wash for those on the go.
2. EcoCare Deluxe: A water-saving wash using biodegradable products.
3. Luxury Detailing: Complete interior and exterior rejuvenation, including wax coating and tire polishing.

**Why Us?**:
- State-of-the-art equipment for a streak-free finish.
- Eco-friendly and water-efficient processes.
- Convenient online booking and contactless payment options.

**Trending Now**: Join the green revolution with our EcoCare package, a favorite among sustainability enthusiasts!`,
  },
  {
    id: 2,
    title: 'Car Rental Services',
    description:
      'Rent top-quality cars for any occasion. Whether it’s a business trip or a weekend getaway, we have a wide range of vehicles to suit your needs.',
    image: images.carRent,
    detailedDescription: `Explore the world your way with our seamless car rental experience. 

    **Packages**:
    1. Daily Drives: Affordable short-term rentals with flexible pickup options.
    2. Luxury Escapes: Premium cars for weddings, business trips, and special events.
    3. Road Trip Ready: SUVs and minivans for adventure seekers.
    
    **Why Us?**:
    - Unlimited mileage and transparent pricing.
    - Complimentary GPS and roadside assistance.
    - Hassle-free cancellations.
    
    **Trending Now**: Luxury Escapes are trending for corporate events and special celebrations!`,
  },
  {
    id: 3,
    title: 'Corporate Fleet Services',
    description:
      'Tailored solutions for corporate clients. Our fleet services ensure your team has reliable transportation at competitive rates.',
    image: images.cfs,
    detailedDescription: `Stay ahead in business with our flexible and dependable corporate fleet packages. 

**Packages**:
1. Executive Commutes: Comfortable vehicles for your top executives.
2. Team Transport: Vans and buses to accommodate your team efficiently.
3. Long-Term Fleet Leasing: Cost-effective solutions for extended periods.

**Why Us?**:
- Dedicated account managers for personalized service.
- Scalable options to match your business growth.
- Regular maintenance and replacements included.

**Trending Now**: Long-term leasing is trending among startups for its cost-effectiveness!`,
  },
  {
    id: 4,
    title: 'Subscription Plans',
    description:
      'Sign up for our monthly subscription plans for discounted rates on car wash and rental services. Save more while enjoying premium services.',
    image: images.sub,
    detailedDescription: `Experience unmatched value and convenience with our subscription plans designed for frequent users. 

**Plans**:
1. Starter Pack: 2 washes and 2 rental days per month.
2. Premium Plus: 5 washes and 5 rental days per month, plus priority scheduling.
3. Ultimate Freedom: Unlimited washes and rentals with VIP perks.

**Why Us?**:
- Exclusive discounts and priority support for subscribers.
- No hidden fees or surprises.
- Easy upgrades and cancellations.

**Trending Now**: The Ultimate Freedom plan is gaining traction among busy professionals!`,
  },
];
